import { useMutation } from 'react-query';
import * as userApi from 'resources/user/user.api';

export default function useAddClientLead() {

  return useMutation((data) => userApi.addClientLead(data), {
    onSuccess: async (response) => {
      if (!response || response.isBadRequest) {
        return null;
      }

      await userApi.sendNewLeadEmail({ clientId: response.id });

      return response;
    },
  });
}
